import React from 'react';
import { Home, Trees, Route, Shield, Wrench, Sparkles } from 'lucide-react';
const SERVICES = [{
  icon: Home,
  title: 'Architectural Uplighting',
  text: 'Highlight the beauty of your home’s facade, columns, and rooflines with warm, precisely aimed uplighting.'
}, {
  icon: Trees,
  title: 'Tree & Cactus Lighting',
  text: 'Dramatic uplighting for palms, saguaros, and desert landscaping that brings your yard to life at night.'
}, {
  icon: Route,
  title: 'Path & Driveway Lighting',
  text: 'Guide guests safely with elegant path lights along walkways, driveways, and garden borders.'
}, {
  icon: Shield,
  title: 'Security Lighting',
  text: 'Deter intruders and increase visibility with strategic, motion-aware lighting around your property.'
}, {
  icon: Wrench,
  title: 'Repairs & Upgrades',
  text: 'Fix failing fixtures, replace halogen with efficient LED, and restore tired systems to full brightness.'
}, {
  icon: Sparkles,
  title: 'Maintenance Plans',
  text: 'Seasonal tune-ups, timer adjustments, and cleaning to keep your lighting flawless year-round.'
}];
export function Services() {
  return <section id="services" className="w-full bg-background py-20 lg:py-28" data-id="element-159" data-mp="2xcb9uvk0104q">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-160" data-mp="2x9yl9zjqjrip">
        <div className="max-w-2xl" data-id="element-161" data-mp="32be2thmpffwc">
          <span className="font-display text-lg tracking-wide text-accent" data-id="element-162" data-mp="3q0gvrlmsgv65">What We Do</span>
          <h2 className="mt-2 font-display text-4xl leading-tight text-foreground sm:text-5xl" data-id="element-163" data-mp="3pymag67lv11j">
            Landscape Lighting Services
          </h2>
          <p className="mt-4 text-lg text-muted-foreground" data-id="element-164" data-mp="3g17us8tiagaa">
            From full custom designs to repairs and upgrades, we handle every part of your
            outdoor lighting — start to finish.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-165" data-mp="24lsxt51arof6">
          {SERVICES.map(s => <article key={s.title} className="group rounded-xl border border-border bg-card p-7 transition-colors hover:border-accent" data-id="element-166" data-mp="29k47nfrldyxe">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent/10 text-accent" data-id="element-167" data-mp="1lj0taf6ihjlk">
                <s.icon className="h-6 w-6" aria-hidden="true" data-id="element-168" data-mp="1gpy1abhdui7h" />
              </div>
              <h3 className="mt-5 font-display text-2xl text-foreground" data-id="element-169" data-mp="1bs671at9mk04">{s.title}</h3>
              <p className="mt-3 leading-relaxed text-muted-foreground" data-id="element-170" data-mp="16ue4lmuzvfho">{s.text}</p>
            </article>)}
        </div>
      </div>
    </section>;
}